// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"57":"b32db001","696":"5151c6a5","925":"3f362282"}[chunkId] + ".chunk.js";
};